export default __webpack_public_path__ + "static/media/shield_blue.60edd5a9.svg";